// extracted by mini-css-extract-plugin
export default {"DeleteMagicBoxLotModal":"DeleteMagicBoxLotModal_DeleteMagicBoxLotModal__WNsas","message":"DeleteMagicBoxLotModal_message__tozTF","controls":"DeleteMagicBoxLotModal_controls__Ub2YI"};